module.exports = __webpack_public_path__ + "static/img/Dylan-Egan.94cf3e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Egan.jpg
// module id = HD/W
// module chunks = 0